import {
  GET_HEADER_WORKFLOW_START,
  GET_HEADER_WORKFLOW_SUCCESS,
  GET_HEADER_WORKFLOW_FAIL,
  CLEAR_HEADER_WORKFLOW,
  SET_HEADER_WORKLFOW_ID,
  UPDATE_HEADER_WORKFLOW_SUCCESS,
  UPDATE_HEADER_WORKFLOW_START,
  UPDATE_HEADER_WORKFLOW_FAIL,
} from 'actions/workflowHeader';
import { UPDATE_WORKFLOW_SUCCESS } from 'actions/workflows';

function getInitialWorkflowHeaderState() {
  return { status: 'NOT_LOADED', workflow: null, isSaving: false };
}

function workflowHeaderReducer(
  state = getInitialWorkflowHeaderState(),
  action,
) {
  switch (action.type) {
    case SET_HEADER_WORKLFOW_ID: {
      return { ...state, workflowId: action.payload };
    }
    case GET_HEADER_WORKFLOW_START: {
      return { ...state, status: 'LOADING' };
    }
    case GET_HEADER_WORKFLOW_SUCCESS: {
      const workflow = action.payload;
      return { ...state, status: 'LOADED', workflow };
    }
    case GET_HEADER_WORKFLOW_FAIL: {
      return { ...state, status: 'ERROR' };
    }
    case CLEAR_HEADER_WORKFLOW: {
      return getInitialWorkflowHeaderState();
    }
    case UPDATE_HEADER_WORKFLOW_START: {
      return { ...state, isSaving: true };
    }
    case UPDATE_WORKFLOW_SUCCESS:
    case UPDATE_HEADER_WORKFLOW_SUCCESS: {
      const stateWorkflow = state.workflow;
      const newWorkflow = action.payload;

      if (!stateWorkflow) {
        return state;
      }

      const workflow = { ...stateWorkflow, ...newWorkflow };

      return {
        ...state,
        workflow,
        isSaving: false,
      };
    }
    case UPDATE_HEADER_WORKFLOW_FAIL: {
      return { ...state, isSaving: false };
    }
    default:
      return state;
  }
}

export default workflowHeaderReducer;
